export const throttle = <T extends (...args: any[]) => void>(
  mainFunction: T,
  delay: number
) => {
  let timerFlag: NodeJS.Timeout | null = null;

  return function (this: any, ...args: Parameters<T>) {
    if (timerFlag === null) {
      mainFunction.apply(this, args);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
};
